import React, { useEffect, useState } from 'react';
import useInView from '../hooks/useInView';

const Counter = ({ value, duration = 1400 }) => {
  const [ref, inView] = useInView({ threshold: 0.4 });
  const [display, setDisplay] = useState('0');

  const numeric = parseInt(String(value).replace(/[^0-9]/g, ''), 10) || 0;
  const prefix = String(value).match(/^[^0-9]*/)?.[0] || '';
  const suffix = String(value).match(/[^0-9]*$/)?.[0] || '';

  useEffect(() => {
    if (!inView) return;

    let start = null;
    let frame;

    const step = (timestamp) => {
      if (start === null) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(Math.round(eased * numeric).toString());
      if (progress < 1) {
        frame = requestAnimationFrame(step);
      }
    };

    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [inView, numeric, duration]);

  return (
    <span ref={ref}>
      {prefix}
      {display}
      {suffix}
    </span>
  );
};

export default Counter;
